import CourseSectionLookup from "./CourseSectionLookup";
import makeLookupModal from "../../UI/LookupModal/LookupModal";
const CourseSectionLookupModal = makeLookupModal(CourseSectionLookup, { pluralEntityName: "Course Sections" });
export default CourseSectionLookupModal;
